import { Button, Modal, Table } from "antd";
import "./styles/PartnersDataPopup.css";
import "./styles/antd.css";
import TableFilter from "./TableFilter";
import { useEffect, useState } from "react";
import config from "../../../config";
import dayjs from "dayjs";
import { downloadPartnerEventsCSV } from "../../../Utils/adminPartnerUtils";
const base_url = config.base_url;

function PartnerDataPopup({
  data,
  modalOpened,
  handleOk,
  handleCancel,
  userId,
}) {
  const [globalSearch, setGlobalSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [userStatusValue, setUserStatusValue] = useState("");
  const [rewardStatusValue, setRewardStatusValue] = useState("");
  const globalSearchFunction = (value) => {
    setGlobalSearch(value);
  };

  //   Unclaimed
  useEffect(() => {
    const filterTable = dataa
      .filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(globalSearch.toLowerCase())
        )
      )
      .filter((o) => {
        if (userStatusValue === undefined) {
          return true;
        }
        return o.customer_status
          .toLowerCase()
          .includes(userStatusValue.toLowerCase());
      })
      .filter((o) => {
        console.log(o);
        if (rewardStatusValue === undefined) {
          return true;
        }
        return o.reward_status
          .toLowerCase()
          .includes(rewardStatusValue.toLowerCase());
      });

    setFilteredData(filterTable);
  }, [globalSearch, rewardStatusValue, userStatusValue]);

  const columns = [
    {
      key: "1",
      title: "Date",
      dataIndex: "date",
      render: (text, record, index) => {
        return dayjs(text).format("YYYY-MM-DD");
      },
    },
    {
      key: "2",
      title: "Email Address",
      dataIndex: "customer_email",
      sorter: (a, b) => {
        return a.customer_email.localeCompare(b.customer_email);
      },
    },
    {
      key: "3",
      title: "User Status",
      dataIndex: "customer_status",
      sorter: (a, b) => {
        return a.customer_status.localeCompare(b.customer_status);
      },
      render: (text, record, index) => {
        if (text === "trial") {
          return <span>Trial Account</span>;
        }
        if (text === "subscription") {
          return <span>Subscribed</span>;
        }
        if (text === "cancelation") {
          return <span>Customer in cancelation Period</span>;
        }
        if (text === "invitation") {
          console.log(record);
          // if (record.canResend) {
          //   return (
          //     <div
          //       style={{
          //         display: "flex",
          //         gap: "3px",
          //       }}
          //     >
          //       <span>Invited</span> <span>|</span>
          //       <span
          //         style={{
          //           color: "#0091EA",
          //           textDecoration: "underline",
          //         }}
          //       >
          //         Resend
          //       </span>
          //     </div>
          //   );
          // } else return <span>Invited</span>;
          return <span>Invited</span>;
        }
        return text;
      },
    },
    {
      key: "4",
      title: "Reward",
      dataIndex: "reward",

      render: (text, record, index) => {
        // console.log(text);
        if (Object.keys(text).length === 0) {
          return <span style={{}}>-</span>;
        } else return <span>${text.money}</span>;
      },
    },
    {
      key: "5",
      title: "Reward Status",
      dataIndex: "reward_status",
      disableSortBy: true,
      sorter: (a, b) => {
        return a.reward_status.localeCompare(b.reward_status);
      },
      render: (text, record, index) => {
        console.log(text);
        return (
          <span
            style={{
              textTransform: "capitalize",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      key: "6",
      title: "Referral Code",
      dataIndex: "code",
      disableSortBy: true,
      sorter: (a, b) => {
        return a.code.localeCompare(b.code);
      },
    },
    {
      key: "7",
      title: "Referral Method",
      dataIndex: "method",
      disableSortBy: true,
      sorter: (a, b) => {
        return a.method.localeCompare(b.method);
      },
      render: (text, record, index) => {
        if (text === "link") {
          return <span>Direct Link</span>;
        }
        if (text === "email") {
          return <span>Invited via Email</span>;
        }
        if (text === "code") {
          return <span>Coupon Code</span>;
        }
        return text;
      },
    },
  ];
  const getReferrals = () => {
    fetch(base_url + "admin/partners/events/partner", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `partner_id=${userId}`,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        // return;
        const data = [];
        res.data.forEach((referral) => {
          data.push({
            date: referral.date,
            customer_email: referral.customer_email,
            customer_status: referral.status.customer_status,
            reward: referral.reward,
            reward_status: referral.reward_status,
            code: referral.code,
            method: referral.method,
            canResend: referral.status.can_resend,
          });
          setDataa(data);
          setFilteredData(data);
        });
      });
  };

  return (
    <Modal
      open={modalOpened}
      onOk={handleOk}
      onCancel={handleCancel}
      className="modal"
      afterOpenChange={(e) => {
        if (e === true) {
          getReferrals();
        }
        if (e === false) {
          setDataa([]);
          setFilteredData([]);
        }
      }}
    >
      <div className="titleContainer">
        <Button
          onClick={() => downloadPartnerEventsCSV(userId)}
          className="exportButton"
        >
          {" "}
          Export To CSV
        </Button>
        <h1>Referred Users For</h1>

        <p>Total Referred :</p>
      </div>

      <TableFilter
        component={"PartnerDataPopup"}
        globalSearch={globalSearchFunction}
        setRewardStatus={setRewardStatusValue}
        setUserStatus={setUserStatusValue}
      />
      <Table
        rowClassName="td"
        dataSource={filteredData}
        columns={columns}
      ></Table>
    </Modal>
  );
}
export default PartnerDataPopup;
